import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  countryAction,
  selectCountries,
  selectCountryStatus,
  selectSelectedCode,
} from "../../../store/redux/country/country-slice";
import styles from "./CountrySelector.module.css";

export const CountrySelector = ({ onCountryChanged }) => {
  const dispatch = useDispatch();
  const countries = useSelector(selectCountries);
  const selectedCode = useSelector(selectSelectedCode);
  const status = useSelector(selectCountryStatus);

  const handleCountryChange = (e) => {
    const countryCode = e.target.value;

    if (countryCode === selectedCode) return;

    dispatch(countryAction.setSelectedCountry(countryCode));

    onCountryChanged?.();
  };

  if (status !== "succeeded") return null;

  return (
    <li className={styles.countrySelector}>
      <div className={styles.selectWrapper}>
        <select
          className={styles.selectInput}
          value={selectedCode}
          onChange={handleCountryChange}
        >
          {Object.entries(countries).map(([code, info]) => (
            <option key={code} value={code}>
              {info.flagEmoji} {info.countryName}
            </option>
          ))}
        </select>
      </div>
    </li>
  );
};
